module.exports = __webpack_public_path__ + "static/media/calendar.e07a82f6.svg";